import { ProductOrderingModeEnumApi } from 'graphql/generated';

export const STORE_NAME = 'app-store';

// UI Timing
export const KEYWORD_DEBOUNCE_DELAY = 1500;
export const SEARCH_DEBOUNCE_TIME = 500;
export const MENU_HOVER_DELAY = 300;
export const MOBILE_MENU_ANIMATION = 150;
export const WARNING_LABEL_DISPLAY_DURATION = 2000;
export const WAIT_BEFORE_RELOAD_MS = 2000;
export const ON_CONFIRM_REDIRECT_DELAY_MS = 500;

// Map
export const MAP_CLUSTER_RADIUS = 75;
export const MAP_CLUSTER_MAX_ZOOM = 18;
export const MAP_CLUSTER_MIN_ZOOM = 1;
export const MAP_ONE_POINT_ZOOM = 15;
export const MAP_SELECTED_STORE_ZOOM = 15;
export const MAP_GEOLOCATED_ZOOM = 10;
export const PICKUP_POINTS_PAGE_SIZE = 20;

// Pagination & page sizes
export const DEFAULT_PAGE_SIZE = 24;
export const BLOG_CATEGORY_PAGE_SIZE = 10;
export const DEFAULT_SORT = ProductOrderingModeEnumApi.PriorityApi as const;

export const STATIC_PAGES = ['static', 'static-presumed-category', 'registration', 'homepage', 'stores'] as const;
export const CUSTOM_PAGE_TYPES = [
    'homepage',
    'registration',
    'stores',
    'wishlist',
    'comparison',
    'orders',
    'order',
    'cart',
    'productMainVariant',
    'transport-and-payment',
    'static-presumed-category',
] as const;

export const MINIMAL_SEARCH_QUERY_LENGTH = 3 as const;

export const NO_OF_HEADER_LINKS = 5;

export const COMPANY_TAX_NUMBER_REQUIRED_LOCALES = ['pl', 'hu', 'pt', 'it-IT'];
export const COMPANY_TAX_ID_NUMBER_REQUIRED_LOCALES = ['pl', 'hu', 'pt', 'it-IT'];

export const ERROR_PAGE_ROUTE = '/404';
export const MIDDLEWARE_STATUS_CODE_KEY = 'middleware-status-code';
export const MIDDLEWARE_STATUS_MESSAGE_KEY = 'middleware-status-message';

export const AUTOCOMPLETE_PRODUCT_LIMIT = 8 as const;
export const AUTOCOMPLETE_CATEGORY_LIMIT = 5 as const;
export const AUTOCOMPLETE_ARTICLE_LIMIT = 5 as const;

export const PRODUCT_LINE_MAX_PRODUCTS_VISIBLE = 6;
export const PRODUCT_LINE_MAX_CATEGORIES_VISIBLE = 10;

export const RECOVER_PASSWORD_HASH_PARAMETER_NAME = 'hash' as const;
export const RECOVER_PASSWORD_EMAIL_PARAMETER_NAME = 'email' as const;

export const SEARCH_QUERY_PARAMETER_NAME = 'q' as const;
export const PAGE_QUERY_PARAMETER_NAME = 'page' as const;
export const FILTER_QUERY_PARAMETER_NAME = 'filter' as const;
export const SORT_QUERY_PARAMETER_NAME = 'sort' as const;
export const SLUG_TYPE_QUERY_PARAMETER_NAME = 'slugType' as const;
export const LOAD_MORE_QUERY_PARAMETER_NAME = 'lm' as const;
export const INTERNAL_QUERY_PARAMETERS = [
    SEARCH_QUERY_PARAMETER_NAME,
    PAGE_QUERY_PARAMETER_NAME,
    FILTER_QUERY_PARAMETER_NAME,
    SORT_QUERY_PARAMETER_NAME,
    SLUG_TYPE_QUERY_PARAMETER_NAME,
    LOAD_MORE_QUERY_PARAMETER_NAME,
];

export type DefaultProductFiltersMapType = {
    flags: Set<string>;
    brands: Set<string>;
    sort: ProductOrderingModeEnumApi;
    parameters: Map<string, Set<string>>;
};

export const getEmptyDefaultProductFiltersMap = (): DefaultProductFiltersMapType => ({
    flags: new Set(),
    brands: new Set(),
    sort: DEFAULT_SORT,
    parameters: new Map(),
});

export const SEO_SENSITIVE_FILTERS = {
    SORT: true,
    AVAILABILITY: false,
    PRICE: false,
    FLAGS: true,
    BRANDS: false,
    PARAMETERS: {
        CHECKBOX: true,
        SLIDER: false,
    },
};

export const GJS_PRODUCTS_SEPARATOR = '|||';
export const GJS_PRODUCT_SEPARATOR = ',';

// Customer section - Order list
export const CUSTOMER_ORDER_PRODUCTS_INITIAL_DISPLAY_LIMIT = 6;

// Pickup points
export const PICKUP_POINT_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;
